import React from "react";
import { Modal, Button } from "react-bootstrap";
import ViewBrand from "./ViewBrand";

const BrandViewModal = ({ show, onHide, brandId }) => {
    return (
        <Modal show={show} onHide={onHide} size="lg" centered scrollable dialogClassName="catalog-modal">
            <Modal.Header closeButton>
                <Modal.Title>Brand Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ViewBrand brandId={brandId} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BrandViewModal;
